import PointsAllocation from './PointsAllocation';

export default PointsAllocation; 